import { ActionTree } from 'vuex'

export default <ActionTree<contact.state.ContactState, RootState>>{
}
